export default "__VITE_ASSET__BpRofBe3__"